import { UserEngagementData } from "../domain/UserEngagementData";
import { UserEngagementRepository } from "../domain/UserEngagementRepository";

export class UserEngagementQuery {
  constructor(
    private readonly userEngagementRepository: UserEngagementRepository,
  ) {}

  execute(): Promise<UserEngagementData> {
    return this.userEngagementRepository.get_data();
  }
}

